// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__6oHm4","title":"Info_title__gns__","selects":"Info_selects__5l4QG","requiredAsterisk":"Info_requiredAsterisk__2uSH-"};